import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { ShardRepositoryListItem } from "../../../api/entities/shard-repository";
import { catchException, commonActions } from "../../../redux/actions/common";
import { shardRepositoryActions } from "../../../redux/actions/shard-repository";
import { IAppState } from "../../../redux/reducers";
import { useNavigate } from "react-router-dom";
import { routeUtils } from "../../../utils/route-utils";
import MoreOptions from "../../shared-ui/more-options";
import { IPopupMenuOption } from "../../shared-ui/popup-menu";
import { IDeleteBlockedConfirmationData } from "../dialogs/delete-blocked-confirmation/delete-blocked-confirmation";
import { shardRepositoryService } from "../../../api/services/shard-repository-service";

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    openDeleteConfirmation: (storageNode: ShardRepositoryListItem) =>
        dispatch(shardRepositoryActions.deleteConfirmation.open(storageNode)),
    openDeleteBlockedConfirmation: (deleteBlockedData: IDeleteBlockedConfirmationData) =>
        dispatch(shardRepositoryActions.deleteBlockedConfirmation.open(deleteBlockedData)),
    startLoading: () =>
        dispatch(commonActions.startLoading()),
    stopLoading: () =>
        dispatch(commonActions.stopLoading())
  };
};

export interface IMoreOptionProps
    extends ReturnType<typeof mapDispatchToProps> {
  data: ShardRepositoryListItem;
}

export const MoreOption = connect(null, mapDispatchToProps)((props: IMoreOptionProps) => {
  const navigate = useNavigate();

  function openDeleteConfirmation() {
    props.startLoading();

    shardRepositoryService.get(props.data.id).then(storageNode => {
      if (!!storageNode.storagePools && storageNode.storagePools.length > 0) {
        props.openDeleteBlockedConfirmation({ storagePools: storageNode.storagePools.map(x => ({ id: x.id, name: x.name })) })
      }
      else {
        props.openDeleteConfirmation(storageNode);
      }
    }).catch(catchException()).finally(props.stopLoading);
  }

  function getOptions(): IPopupMenuOption[] {
    const result = [
      {
        label: "Manage",
        onClick: () => navigate(routeUtils.getRouteToShardRepositoryDetails(props.data.id.toString()))
      },
      {
        label: "Delete",
        onClick: openDeleteConfirmation
      },
    ];
    return result;
  }

  return (
    <MoreOptions
      options={getOptions()}
    />
  );
});
